import { ApiClient } from '@/api/propertyTax/apiClient'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { GlobalError } from '@/utils/globalError/GlobalError'

export const useProjectApi = () => {
  const apiClient = new ApiClient()

  const getProjectList = async <T>(): Promise<T> => {
    try {
      return await apiClient.request<T>({
        method: 'GET',
        url: '/project/dup/'
      })
    } catch (error) {
      if (error instanceof GlobalError) {
        throw new GlobalError(ERROR_CODES._815101_GET_PROJECT_LIST_ERROR)
      }
      throw error
    }
  }
  return {
    getProjectList
  }
}
